/**
 *
 * Asynchronously loads the component for TeamTags
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
